import { c as _c } from "react/compiler-runtime";
import { IcoArrowUpRight16 } from '@onefootprint/icons';
import type { EntityOnboardingBusinessInfo } from '@onefootprint/request-types/dashboard';
import { LinkButton, Shimmer } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import useEntity from '@/components/entities/components/details/hooks/use-entity';
const BusinessLink = t0 => {
  const $ = _c(12);
  const {
    businessInfo
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboardings.details"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const {
    fpBid,
    onboardingId
  } = businessInfo;
  const {
    data: business,
    isPending
  } = useEntity(fpBid);
  let t2;
  if ($[1] !== business?.data) {
    t2 = business?.data.find(_temp)?.value;
    $[1] = business?.data;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const businessName = t2 as string;
  if (isPending) {
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <Shimmer height="20px" width="200px" />;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    return t3;
  }
  let t3;
  if ($[4] !== onboardingId) {
    t3 = new URLSearchParams({
      onboarding_id: onboardingId
    });
    $[4] = onboardingId;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = `/businesses/${fpBid}?${t3}`;
  let t5;
  if ($[6] !== businessName || $[7] !== t) {
    t5 = businessName || t(_temp2);
    $[6] = businessName;
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <LinkButton href={t4} target="_blank" variant="label-3" iconComponent={IcoArrowUpRight16} className="underline! underline-offset-2 [&_svg]:size-3.5">{t5}</LinkButton>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
export default BusinessLink;
function _temp(attribute) {
  return attribute.identifier === "business.name";
}
function _temp2($) {
  return $.businessLink;
}